"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeaturedTag = void 0;
var _react = _interopRequireDefault(require("react"));
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _config = require("../../../config");
var _ProductStatusWrapper = require("../../tableComponents/bodyComponents/ProductStatusWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ProductFeaturing;
try {
  ProductFeaturing = require("react-platform-productfeature/dist/ProductFeaturing/ProductFeaturingDialog").ProductFeaturing;
} catch (error) {}
var FeaturedTag = function FeaturedTag(props) {
  var product = props.product,
    displayPosition = props.displayPosition;
  var isFeatured = function isFeatured(product) {
    return product.tags.find(function (tag) {
      return tag.uuid === _config.PRODUCT_FEATURED_TAG_UUID;
    });
  };
  if (!ProductFeaturing) return null;
  return isFeatured(product) ? displayPosition === "right" && /*#__PURE__*/_react.default.createElement(_ProductStatusWrapper.ProductStatusWrapper, {
    status: "published"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "featured",
    defaultMessage: "featured"
  })) : displayPosition === "left" && /*#__PURE__*/_react.default.createElement(ProductFeaturing, {
    productId: product.id
  });
};
exports.FeaturedTag = FeaturedTag;